import { render, staticRenderFns } from "./TIPO_CABECALHO.vue?vue&type=template&id=651e5f8d"
import script from "./TIPO_CABECALHO.vue?vue&type=script&lang=js"
export * from "./TIPO_CABECALHO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports